/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Carbon Black Config
 */
export interface CarbonBlackConfig { 
    /**
     * API client location
     */
    apiClientLocation?: string;
    /**
     * API client timestamp
     */
    apiClientTimestamp?: string;
    /**
     * API endpoint
     */
    apiEndpoint?: string;
    /**
     * The ARN of the CWP Appliance OVA file.
     */
    cwpApplianceOva?: string;
    /**
     * CB sensor versions to ignore
     */
    ignoreCbSensorVersions?: string;
    /**
     * Org Id
     */
    orgId?: number;
    /**
     * Org Key
     */
    orgKey?: string;
    /**
     * Registered or Unregistered
     */
    registered: boolean;
    vlcrManaged?: boolean;
}

